export default [
  "Sean",
  "Chloe",
  "Tony",
  "Etsuko",
  "Vicky",
  "Cindy",
  "Juan",
  "Charley",
  "Lorenzo",
  "Larry",
  "Victor",
  "Misty",
  "Bandit",
  "Ivan",
  "Henri",
  "Danny",
  "Harvey",
  "Rose",
  "Milo",
  "Helene",
  "Michael",
  "Charlie",
  "Junko",
  "Emi",
  "Buster",
  "Michiyo",
  "Coco",
  "Leo",
  "Sheba",
  "Midnight",
  "Jeanne",
  "Pablo",
  "Ernesto",
  "Sugar",
  "Nate",
  "Debby",
  "Shadow",
  "Dean",
  "Maggie",
  "Oreo",
  "Noel",
  "Nadine",
  "Lili",
  "Bonnie",
  "Ophelia",
  "Jack",
  "Rie",
  "Sophie",
  "Naoko",
  "Felix",
  "Socks",
  "Gert",
  "Florence",
  "Odette",
  "Chiaki",
  "Earl",
  "Snuggles",
  "Rocky",
  "Iris",
  "Virginie",
  "Mieko",
  "Lily",
  "Irene",
  "Salem",
  "Miyuki",
  "Dusty",
  "Chris",
  "Danielle",
  "Cali",
  "Otto",
  "Snowball",
  "Kate",
  "Bubba",
  "Tanya",
  "Fabian",
  "Mindy",
  "Nana",
  "Kumiko",
  "Josephine",
  "Lisa",
  "Kazuko",
  "Harley",
  "Zoey",
  "Ginger",
  "Jasmine",
  "Nicholas",
  "Bret",
  "Zoe",
  "Richard",
  "Luna",
  "Grace",
  "Miyako",
  "Beryl",
  "Sasha",
  "Kaori",
  "Bella",
  "Arlene",
  "Yumi",
  "Isaac",
  "Lola",
  "Alex",
  "Stan",
  "Omar",
  "Youko",
  "Pumpkin",
  "Sally",
  "Mittens",
  "Spooky",
  "Cuddles",
  "Van",
  "Snickers",
  "Missy",
  "Michelle",
  "Patty",
  "Max",
  "Miharu",
  "Chester",
  "Bertha",
  "Erin",
  "Annie",
  "Rebekah",
  "Tiger",
  "Miwa",
  "Gordon",
  "Mimi",
  "William",
  "Leslie",
  "Kirk",
  "Callie",
  "Samantha",
  "Reina",
  "Hitomi",
  "Baby",
  "Isidore",
  "Rita",
  "Emily",
  "Alberto",
  "Aki",
  "Buddy",
  "Sam",
  "Cristobal",
  "Barry",
  "Willow",
  "Paula",
  "Nanaho",
  "Cleo",
  "Vince",
  "Gracie",
  "Lucy",
  "Philippe",
  "Sebastien",
  "Toby",
  "Wanda",
  "Sammy",
  "Edouard",
  "Teresa",
  "Arthur",
  "Ayumi",
  "Humberto",
  "Paloma",
  "Jose",
  "Jerry",
  "Cookie",
  "Precious",
  "Sadie",
  "Hermine",
  "Rafael",
  "Gustav",
  "Kiki",
  "Gizmo",
  "Whiskers",
  "Simba",
  "Dennis",
  "Marco",
  "Nala",
  "Valerie",
  "Lee",
  "Peanut",
  "Casper",
  "Bear",
  "Lilly",
  "Maria",
  "Fluffy",
  "Joyce",
  "Katrina",
  "Nicole",
  "Itoe",
  "Erika",
  "Abby",
  "Simon",
  "Scooter",
  "Gaston",
  "Shary",
  "Dolly",
  "Tammy",
  "Molly",
  "George",
  "Toshie",
  "Claudette",
  "Trouble",
  "Bob",
  "Oliver",
  "Tigger",
  "Garfield",
  "Isabel",
  "Fay",
  "Tomas",
  "Jane",
  "Bailey",
  "Angel",
  "Jasper",
  "Wilfred",
  "Tom",
  "Akane",
  "Wendy",
  "Peter",
  "Sachiko",
  "Hanna",
  "Loki",
  "Olga",
  "Ana",
  "Bobby",
  "Franklin",
  "Muffin",
  "Wilma",
  "Allison",
  "Pepper",
  "Patches",
  "Rene",
  "Kyle",
  "Frances",
  "Mia",
  "Princess",
  "Sassy",
  "Kathy",
  "Rascal",
  "Boo",
  "Bill",
  "Walter",
  "Karl",
  "Chantal",
  "Sandy",
  "Daisy",
  "Luke",
  "Gabielle",
  "Oscar",
  "Teddy",
  "Karen",
  "Smokey",
  "Sayuri"
];


// WEBPACK FOOTER //
// ./src/names.js